import React from "react";
import ReactApexChart from "react-apexcharts";

const Mixed = ({ graphSeries, graphOptions }) => {
  return (
    <>
      <div id="chart">
        {/* 画面幅1300px以上で表示　グラフ幅100% */}
        <ReactApexChart
          options={graphOptions}
          series={graphSeries}
          type="bar"
          height={350}
          className="marketCharts"
        />

        {/* 画面幅1300px以下で表示 グラフ幅1080px（固定）、横スクロール実装 */}
        <ReactApexChart
          options={graphOptions}
          series={graphSeries}
          type="bar"
          height={350}
          width={1080}
          style={{ overflow: "scroll" }}
          className="marketCharts_lg"
        />
      </div>
    </>
  );
};

export default Mixed;
